/**
 * Ensures an array of BookMarker objects includes all children
 *
 * @method getMarkersWithDescendentsForMarkers
 * @param {Array<BookMarker>} markers - list of markers
 * @returns {Array} array of BookMarker objects that includes all children of included BookMarker objects
 */
const getMarkersWithDescendentsForMarkers = (markers) => {
  return [...new Set(markers.map((marker) => marker.withDescendents).flat())];
};

export default getMarkersWithDescendentsForMarkers;
